export default {"src":"/_next/static/media/close-dark.f83c1b40.svg","height":12,"width":12};